import { inject } from "@angular/core";
import { CanActivateChildFn, Router } from "@angular/router";

import { AuthService } from "./auth.service";

/** El portal de clientes vive bajo /CLIENTE (ojo: /CLIENTES es la gestión interna). */
const RAIZ_PORTAL = "/CLIENTE";

/** A donde cae el cliente si pide una pantalla interna. */
const INICIO_PORTAL = "/CLIENTE/incidencias";

/**
 * Pantallas de SU propia cuenta que el cliente sí abre (el avatar del navbar
 * lleva a Ajustes): foto de perfil y cambio de contraseña. El servidor le
 * deja justo esas dos operaciones.
 */
const CUENTA_DEL_CLIENTE = ["/admin/ajustes", "/admin/password"];

/** Si quien está en sesión es un usuario del portal de clientes (tipoUsuario CLIENTE). */
export function esUsuarioCliente(authService: AuthService): boolean {
  try {
    const tipo = authService.getCosData()?.usuario?.tipoUsuario;
    return String(tipo ?? "").trim().toUpperCase() === "CLIENTE";
  } catch {
    return false;
  }
}

/**
 * Separa el portal de clientes del COS: el CLIENTE solo navega por /CLIENTE/**
 * (y su cuenta); el personal nunca entra a /CLIENTE/**.
 *
 * Es solo experiencia de usuario, para que nadie aterrice en una pantalla
 * que el servidor le va a negar. La seguridad de verdad está en el backend
 * (PortalClienteInterceptor responde 403 a lo que no es del portal).
 */
export const portalPorTipoDeUsuario: CanActivateChildFn = (_ruta, estado) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const url = estado.url.split(/[?#;(]/)[0];
  const enPortal = url === RAIZ_PORTAL || url.startsWith(RAIZ_PORTAL + "/");

  if (esUsuarioCliente(authService)) {
    return enPortal || CUENTA_DEL_CLIENTE.includes(url) ? true : router.parseUrl(INICIO_PORTAL);
  }
  return enPortal ? router.parseUrl("/dashboard") : true;
};
